// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3uh_g","selects":"Documents_selects__2gqw-"};